import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import type { CountryOutput } from 'types/api'

export const countriesQueryKey = ['countries']

type UsePlacesArgs = {
  search: string
}

export function useCountries(args: UsePlacesArgs) {
  const { search } = args

  const params = useMemo(
    function getParams(): URLSearchParams {
      const params = new URLSearchParams()

      if (search) {
        params.set('search', search)
      }

      return params
    },
    [search]
  )

  async function getCountries() {
    const response = await apiClient.get<CountryOutput[]>(
      `${SNA_PREFIX}countries?${params.toString()}`
    )

    return response.data
  }

  return useQuery({
    queryFn: getCountries,
    queryKey: [...countriesQueryKey, params.toString()]
  })
}
